import React from 'react'
import { TableHeader } from '../../../commons'
import { RECURRING_JOBS_SETTING_LIST_TABLE_HEADER } from '../../../../constant/tableHeadersConstants/Jobs/recurringJobsSettingListTableHeader'
import RecurringJobsSettingTableData from './RecurringJobsSettingTableData'
import { JOBS_TABLE_HEADER } from '../../../../constant/tableHeadersConstants/Jobs/JobsTableHeader'
type AppProps = {
  recurringJobsList: any;
  handleEditRecurringJobSetting:(data:any)=>void;
}
const RecurringJobsSettingTable = ({ recurringJobsList,handleEditRecurringJobSetting }: AppProps) => {
  return (
    <div className='jobsType'>
      <table className="table thead-light table-bordered">
        <thead className='text-start sticky-table-header'>
          <TableHeader
            tableHeader={RECURRING_JOBS_SETTING_LIST_TABLE_HEADER}
          />
        </thead>
        <tbody>
          <RecurringJobsSettingTableData
            handleEditRecurringJobSetting={handleEditRecurringJobSetting}
            recurringJobsList={recurringJobsList}
            tableHeader={RECURRING_JOBS_SETTING_LIST_TABLE_HEADER}
          />
        </tbody>
      </table>
    </div>
  )
}

export default RecurringJobsSettingTable